import {
  DivisionsCentersFormattedItemType,
  DivisionsFormattedItemType,
} from '@type/dashboard';
import { numberLanguageFormatter } from '@utils/utils';

export const summaryChartOption = (value: number | string) => {
  return {
    series: [
      {
        type: 'gauge',
        startAngle: 90,
        endAngle: -270,
        pointer: {
          show: false,
        },
        progress: {
          show: true,
          overlap: false,
          roundCap: true,
          clip: false,
          itemStyle: {
            color: '#555961',
            borderWidth: 1,
            borderColor: '#555961',
          },
        },
        axisLine: {
          lineStyle: {
            width: 10,
          },
        },
        splitLine: {
          show: true,
          distance: 0,
          length: 0,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
          distance: 40,
        },
        data: [
          {
            name: 'Perfect',
            value: value,
            title: {
              offsetCenter: ['0%', '10%'],
            },
            detail: {
              valueAnimation: true,
              offsetCenter: ['0%', '0%'],
            },
          },
        ],
        title: {
          show: false,
          fontSize: 16,
        },
        detail: {
          width: '100%',
          height: '10%',
          fontSize: 20,
          color: '#ffffff',
          formatter: (params: any) => {
            return `${numberLanguageFormatter(params || 0)} %`;
          },
        },
      },
    ],
  };
};

export const divisionBarChartOption = (
  data: DivisionsFormattedItemType | undefined,
) => {
  return {
    tooltip: {
      trigger: 'item',
      axisPointer: {
        type: 'shadow',
      },
      formatter: (params: any) => {
        return `<h4 style="color: rgb(0,0,0); white-space: normal;">নির্বাচনী এলাকার নাম: ${
          params?.data?.name
        }</h4>
        </p><p style="color: rgb(0,0,0); white-space: normal;">জেলার নাম: ${
          params?.data?.zillaName || ''
        }</p>
        <p style="color: rgb(0,0,0); white-space: normal;">মোট ভোটার: ${numberLanguageFormatter(
          params?.data?.totalVoters || 0,
        )}
        <p style="color: rgb(0,0,0); white-space: normal;">প্রদত্ত ভোট: ${numberLanguageFormatter(
          params?.data?.castedVote || 0,
        )}</p><p style="color: rgb(0,0,0); white-space: normal;">প্রেরিত ভোট কেন্দ্রের সংখ্যা: ${numberLanguageFormatter(
          params?.data?.doneVoteCenter || 0,
        )}</p><p style="color: rgb(0,0,0); white-space: normal;">শতকরা হার (আনুমানিক): ${numberLanguageFormatter(
          params?.data?.value || 0,
        )} %</p>`;
      },
      textStyle: {
        ellipsis: '...',
      },
    },

    grid: {
      left: '1%',
      right: '1%',
      bottom: '3%',
      containLabel: true,
    },

    xAxis: {
      show: true,
      type: 'category',
      alignTicks: true,
      splitNumber: 1,
      axisTick: {
        show: true,
        length: 5,
        interval: 0,
        inside: false,
        alignWithLabel: true,
      },
      axisLabel: {
        width: 150,
        overflow: 'truncate',
        ellipsis: '...',
        interval: 0,
        rotate: 75,
        hideOverlap: false,
        color: '#000000',
        extraCssText: 'width:100%;',
      },

      data: data?.election_setting_name || [],
    },

    yAxis: {
      show: true,
      type: 'value',
      min: 0,
      max: 100,
      alignTicks: false,
      splitNumber: 10,
      axisTicks: {
        show: false,
      },
      axisLabel: {
        rotate: 0,
        interval: 0,
        formatter: (params: any) => {
          return `${numberLanguageFormatter(params || 0)} %`;
        },
        hideOverlap: true,
        color: '#000000',
        overflow: 'truncate',
        ellipsis: '...',
      },
      splitLine: {
        show: false,
      },
      data: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
    },

    series: [
      {
        name: 'Percentage',
        type: 'bar',
        stack: 'total',
        label: {
          show: true,
          rotate: 0,
          position: 'top',
          fontSize: 10,
          color: '#000000',
          formatter: (params: any) => {
            return `${numberLanguageFormatter(params?.data?.value || 0)}`;
          },
        },
        barGap: '50%',
        barMinWidth: 25,
        barMaxWidth: 25,
        showBackground: true,
        data: data?.election_setting_value || [],
      },
    ],
  };
};

export const divisionLineChartOption = (
  data: DivisionsFormattedItemType | undefined,
) => {
  return {
    tooltip: {
      trigger: 'item',
      axisPointer: {
        type: 'shadow',
      },
      formatter: (params: any) => {
        return `<h4 style="color: rgb(0,0,0); white-space: normal;">নির্বাচনী এলাকার নাম: ${
          params?.data?.name
        }</h4>
        <p style="color: rgb(0,0,0); white-space: normal;">জেলার নাম: ${
          params?.data?.zillaName || ''
        }</p>
        <p style="color: rgb(0,0,0); white-space: normal;">মোট ভোটার: ${numberLanguageFormatter(
          params?.data?.totalVoters || 0,
        )}</p><p style="color: rgb(0,0,0); white-space: normal;">প্রদত্ত ভোট: ${numberLanguageFormatter(
          params?.data?.castedVote || 0,
        )}</p><p style="color: rgb(0,0,0); white-space: normal;">প্রেরিত ভোট কেন্দ্রের সংখ্যা: ${numberLanguageFormatter(
          params?.data?.doneVoteCenter || 0,
        )}</p><p style="color: rgb(0,0,0); white-space: normal;">শতকরা হার (আনুমানিক): ${numberLanguageFormatter(
          params?.data?.value || 0,
        )} %</p>`;
      },
      textStyle: {
        ellipsis: '...',
      },
    },

    grid: {
      left: '1%',
      right: '1%',
      bottom: '3%',
      containLabel: true,
    },

    xAxis: {
      show: true,
      type: 'category',
      boundaryGap: true,
      alignTicks: true,
      axisTick: {
        show: true,
        alignWithLabel: true,
        inside: false,
        length: 5,
        interval: 0,
      },
      axisLabel: {
        width: 150,
        interval: 0,
        rotate: 75,
        hideOverlap: false,
        color: '#000000',
        overflow: 'truncate',
        ellipsis: '...',
      },
      splitLine: {
        show: false,
      },
      data: data?.election_setting_name || [],
    },

    yAxis: {
      show: true,
      type: 'value',
      min: 0,
      max: 100,
      alignTicks: false,
      splitNumber: 10,
      axisTick: {
        show: false,
        alignWithLabel: false,
        inside: false,
        length: 0,
        interval: 0,
      },
      axisLabel: {
        show: true,
        formatter: (params: any) => {
          return `${numberLanguageFormatter(params || 0)} %`;
        },
        interval: 0,
        rotate: 0,
        hideOverlap: true,
        color: '#000000',
        overflow: 'truncate',
        ellipsis: '...',
      },
      data: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
    },

    series: [
      {
        type: 'line',
        smooth: true,
        name: 'Percentage',
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: data ? colorPalette[data?.id - 2][0] : '',
            },
            {
              offset: 1,
              color: data ? colorPalette[data?.id - 2][1] : '',
            },
          ],
          global: false,
        },
        stack: 'total',
        label: {
          show: true,
          rotate: 0,
          color: '#000000',
          formatter: (params: any) => {
            return `${numberLanguageFormatter(params?.data?.value || 0)}`;
          },
        },
        showBackground: true,
        data: data?.election_setting_value || [],
      },
    ],
  };
};

export const divisionConstituencyCentersOption = (
  data: DivisionsCentersFormattedItemType | undefined,
) => {
  return {
    tooltip: {
      trigger: 'item',
      position: ['0%', '2%'],
      formatter: (params: any) => {
        return `<h4 style="color: rgb(0,0,0); white-space: normal;">কেন্দ্রের নাম: ${
          params?.data?.centerSerial
        } - ${
          params?.data?.centerName || ''
        }</h4><p style="color: rgb(0,0,0); white-space: normal;">মোট ভোটার: ${numberLanguageFormatter(
          params?.data?.totalVoters || 0,
        )}</p><p style="color: rgb(0,0,0); white-space: normal;">প্রদত্ত ভোট: ${numberLanguageFormatter(
          params?.data?.castedVote || 0,
        )}</p><p style="color: rgb(0,0,0); white-space: normal;">শতকরা হার (আনুমানিক): ${numberLanguageFormatter(
          params?.data?.value || 0,
        )} %</p>`;
      },
      textStyle: {
        ellipsis: '...',
      },
    },

    color: [
      '#ff00cc',
      '#333399',

      '#decba4',
      '#3e5151',

      '#91eae4',
      '#7f7fd5',

      '#ffd3a5',
      '#fd6585',

      '#ffe32c',
      '#52acff',

      '#34e89e',
      '#0f3443',

      '#7bc393',
      '#31b7c2',

      '#f64f59',
      '#12c2e9',
    ],

    series: [
      {
        name: 'Center Details',
        type: 'pie',
        radius: ['25%', '50%'],
        labelLine: {
          length: 20,
        },
        label: {
          show: true,
          formatter: (params: any) => {
            return `${params?.data?.centerSerial} : ${numberLanguageFormatter(
              params?.data?.value || 0,
            )} %`;
          },
          color: 'rgb(0,0,0)',
          backgroundColor: '#F6F8FC',
          borderColor: '#8C8D8E',
          borderWidth: 1,
          padding: 5,
          borderRadius: 4,
        },
        data: data?.centers_info || [],
      },
    ],
  };
};

export const colorPalette = [
  ['#cd6a65', '#c9615c'],

  ['#718355', '#87986a'],

  ['#9631b7', '#9b36ad'],

  ['#5a79d7', '#4263d1'],

  ['#8c68c8', '#835fc5'],

  ['#c29025', '#c2901c'],

  ['#a36361', '#ac6a67'],

  ['#488c78', '#44846f'],
];

export const API_REFETCH_TIME = 180;
